import React, { FC, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";

import { CITypes } from "../../services/enums";
import {
  IInstrument,
  IInstrumentHistoricalData,
} from "../../models/instrument.model";
import { UIRoutes } from "../../router";
import CommonService from "../../services/common.service";
import useHttpGet from "../../hooks/useHttpGet";
import { IResultResponse } from "../../models/response/result.model";
import { APIRoutes } from "../../http";
import { currencyFormat } from "../../services/constants";
import { ICryptoIndex } from "../../models/cryptoindex.model";

interface IProps {
  index: ICryptoIndex;
}

const Instruments: FC<IProps> = ({ index }) => {
  const [filter, setFilter] = useState({
    sortPropertyName: "id",
    sortAscending: true,
  });

  const { fetchedData, loading } = useHttpGet<IResultResponse<IInstrument[]>>(
    `${APIRoutes.INSTRUMENT_FOR_INDEX}/${index.id}`,
    {
      dependencies: [index.id, filter],
      condition: !!index?.id,
      defaultValue: { result: [] as IInstrument[] },
      query: filter,
    }
  );

  const handleTableChange = (newPagination: any, filters: any, sorter: any) => {
    if (!!sorter) {
      const newFilter: any = {
        sortPropertyName: sorter.field,
        sortAscending: sorter?.order === "ascend",
      };

      setFilter(newFilter);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "sortNumber",
      key: "sortNumber",
      width: 50,
      render: (_: any, __: any, index: number) => (
        <>{index + 1}</>
      )
    },
    {
      title: "Asset",
      dataIndex: "name",
      key: "asset",
      render: (text: string, record: IInstrument) => (
        <div className="d-flex align-items-center" key={record?.id}>
          <img src={record?.image} style={{ maxHeight: '20px', marginRight: '5px' }} />
          <Link
            to={`/${UIRoutes.VIEW_INSTRUMENT_BASE}/${CommonService.replaceSymbol(record?.name)}/${record?.id}`}
          >
            {text}
          </Link>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "lastHistoricalData",
      key: "price",
      render: (text: IInstrumentHistoricalData) =>
        CommonService.toLocalNum(text?.adjClose, currencyFormat),
    },
    {
      title: "Market CAP",
      dataIndex: "lastHistoricalData",
      key: "marketCAP",
      render: (text: IInstrumentHistoricalData) =>
        CommonService.toLocalNum(text?.marketCap, currencyFormat),
    },
    {
      title: "24H Change",
      dataIndex: "lastHistoricalData",
      width: 130,
      key: "changePercent",
      render: (text: IInstrumentHistoricalData) => (
        <span className={CommonService.numberColor(text?.changePercent || 0)}>
          {`${text?.changePercent || 0} %`}
        </span>
      ),
    },
  ];

  return (
    <div>
      <h3 className="mt-1">
        <span className="mr-0_5">INSTRUMENTS FOR {index.name}</span>
      </h3>
      <Table
        size="small"
        columns={columns}
        dataSource={fetchedData?.result || []}
        pagination={false}
        loading={loading}
        onChange={handleTableChange}
        scroll={{ y: 440 }}
        rowKey={(record) => record?.id}
      />
    </div>
  );
};

export default Instruments;
